import * as NEA from "fp-ts/lib/NonEmptyArray";

const alphaNumeric = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
// MediaCdn.scala needs to change when this changes
const hashLength: number = 8;

export const generateHash = (): string => {
  return NEA.range(0, hashLength).reduce((s: string) => s + alphaNumeric.charAt(Math.floor(Math.random() * alphaNumeric.length)), "");
};
